import request from '@/utils/http.js';

/**
 * 用户创建举报
 * @param {*} data 
 * @param {*} options 
 * @returns 
 */
const createFeedback = (data = {}) => {
  const url = '/v3/interacts/report/user-create-report';
  return request({
    url,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

export default {
  createFeedback
};
